import { Reveal } from "@/components/Reveal";
import { STATS } from "@/data/eventData";

const Stats = () => (
    <section data-testid="stats-section" className="border-b border-cream/5">
        <div className="mx-auto grid max-w-[1400px] grid-cols-2 lg:grid-cols-4">
            {STATS.map((stat, i) => (
                <Reveal
                    key={stat.label}
                    delay={i * 0.08}
                    className={`border-cream/5 px-6 py-12 md:px-10 md:py-16 ${
                        i % 2 === 0 ? "border-r" : ""
                    } ${i < 2 ? "border-b lg:border-b-0" : ""} ${
                        i < 3 ? "lg:border-r" : ""
                    }`}
                >
                    <p
                        data-testid={`stat-value-${i}`}
                        className="font-serif text-5xl font-light tracking-tight text-cream md:text-6xl lg:text-7xl"
                    >
                        {stat.value}
                    </p>
                    <div className="mt-4 flex items-center gap-3">
                        <span className="h-px w-6 bg-crimson" aria-hidden="true" />
                        <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.3em] text-ash md:text-[11px]">
                            {stat.label}
                        </p>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);

export default Stats;
